import styles from './ContactUs.module.css';

export default function ContactUs() {
  return (
    <div className={styles.container}>
      <div className={styles.overlay} />
      <div className={styles.content}>
        <h1 className={styles.title}>Contact Us</h1>

        <div className={styles.contactInfo}>
          <div className={styles.infoSection}>
            <h2>Get in Touch</h2>
            <p>
              We're here to answer any questions about MyPeopleDatabase, including features,
              pricing, or technical support.
            </p>
            <div className={styles.contactMethod}>
              <strong>Email:</strong>
              <a href="mailto:support@mypeopledatabase.com" className={styles.link}>
                support@mypeopledatabase.com
              </a>
            </div>
          </div>

          <div className={styles.infoSection}>
            <h2>FAQ</h2>
            <div className={styles.faqItem}>
              <h3>What makes MyPeopleDatabase unique?</h3>
              <p>
                Unlike other contact management systems, MyPeopleDatabase gives you complete
                ownership of your data and includes special features like preserving records of
                people who have passed away while removing them from active contacts.
              </p>
            </div>
            <div className={styles.faqItem}>
              <h3>How secure is my data?</h3>
              <p>
                Security is our top priority. Your data is encrypted and stored securely, and we
                never share your information with third parties.
              </p>
            </div>
          </div>
        </div>

        <div className={styles.formContainer}>
          <h2 className={styles.formTitle}>Send Us a Message</h2>

          <div className={styles.emailInstruction}>
            <p>To get in touch with us, please send an email directly to:</p>
            <div className={styles.emailAddress}>
              <a href="mailto:support@mypeopledatabase.com" className={styles.emailLink}>
                support@mypeopledatabase.com
              </a>
            </div>
            <p>We'll respond to your inquiry as soon as possible!</p>
          </div>
        </div>
      </div>
    </div>
  );
}
